import ky from 'ky';

export const carmaCsrBizClient = ky.create({
  prefixUrl: `${process.env.REACT_APP_BIZ_API_URL}/`,
  timeout: 15000,
});
